/* eslint-disable @typescript-eslint/no-explicit-any */
export const updateTrackingProperties = (data: any, componentname: string) => {
  const cardsArr: any = [];
  Object.keys(data.cqItems).forEach(key => {
    const item = data.cqItems[key][':items'][componentname];
    const { header, ctaLinkText, trackingProperties } = item;
    if (item && item.trackingProperties) {
      item.trackingProperties.location = header || trackingProperties?.location;
      item.trackingProperties.cardLocation = header || trackingProperties?.cardLocation;
      item.trackingProperties.description = ctaLinkText || trackingProperties?.description;
      item.trackingProperties.trackingDescription = ctaLinkText || trackingProperties?.trackingDescription;
    }
    cardsArr.push(item);
  });
  return cardsArr;
};

export const getLeisureComponent = (innerComp: string) => {
  console.log('Destination innerComp >> ', innerComp);
  // leisure
  if (innerComp === 'DestinationsAccordion') {
    return import(`../organisms/DestinationAccordionContainerEnhanced/index`).then(module => ({
      default: module['DestinationAccordionContainerEnhanced'],
    }));
  }

  return import(`../../../mi-common-static-components/src/organisms/${innerComp}/index`).then(module => ({
    default: module[innerComp],
  }));
};
